// extracted by mini-css-extract-plugin
export default {"layoutBox":"layoutBox_hidpp","title":"title_NRraj","content":"content_TwLU4","image":"image_K6Zmj"};